// extracted by mini-css-extract-plugin
export default {"container":"Why_and_Safety_container__IEwhf"};